import { Drawer } from '@mui/material';
import type { ReactNode } from 'react';
import { NAVBAR_HEIGHT } from './drawer.constants';
import styles from './sidePanelDrawer.module.css';

interface SidePanelDrawerProps {
  open: boolean;
  onClose: () => void;
  /** id of the heading that names the dialog (a11y). */
  ariaLabelledBy?: string;
  children: ReactNode;
}

/**
 * Generic right-anchored drawer shell used by the column configurator and the
 * advanced-filters panel. Owns the paper geometry (width, navbar offset, shadow,
 * rounded top-left) and the shared design tokens (`sidePanelDrawer.module.css`
 * exposes `--gray-*`, `--font-*`, `--icon-*`, …). Compose the header / meta /
 * search / body / footer as children.
 */
export function SidePanelDrawer({ open, onClose, ariaLabelledBy, children }: SidePanelDrawerProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          className: styles.drawer,
          'aria-labelledby': ariaLabelledBy,
          sx: {
            width: 'var(--drawer-width)',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: `-8px 0 40px var(--shadow-14), -2px 0 8px var(--shadow-6)`,
            mt: `${NAVBAR_HEIGHT}px`,
            height: `calc(100% - ${NAVBAR_HEIGHT}px)`,
            borderTopLeftRadius: 'var(--border-radius)',
          },
        },
      }}
    >
      {children}
    </Drawer>
  );
}
